import { Divider, Container, Drawer, ScrollArea } from '@mantine/core'
import { LinksGroup } from '../NavBarLinksGroup'
import { NavigationTabs } from '../Navigation'
import useNavigationCollapse from '@/hooks/useNavigationCollapse'
import { useTranslation } from 'react-i18next'

const MobileNavigation = ({ system, render }: NavigationTabs & { render: boolean }) => {
  const { collapsed, setCollapsed } = useNavigationCollapse({
    defaultCollapsed: true,
  })
  const { t } = useTranslation('nav')

  if (!render) return null

  return (
    <Container size="xs" display={{ base: 'block', sm: 'none' }}>
      <Drawer
        opened={!collapsed}
        onClose={() => setCollapsed(true)}
        size="100%"
        padding="md"
        title={t('senseUI')}
        zIndex={1000000}
      >
        <ScrollArea h="calc(100vh - 60px)" pt="xs">
          <Divider my="xs" />
          {system.map(item => (
            <LinksGroup
              {...item}
              key={item.label}
              label={t(item.label as Parameters<typeof t>[0])}
              links={item.links?.map(l => ({ ...l, label: t(l.label as Parameters<typeof t>[0]) }))}
            />
          ))}
        </ScrollArea>
      </Drawer>
    </Container>
  )
}

export default MobileNavigation
